import React, { useState, useEffect } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TableMyshopAccountant from './report/TableMyshopAccountant';
import TableAccounting from './report/TableAccounting';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import ModalItemshopAccountant from './modal/ModalItemshopAccountant';
import { ContentHeader } from '@components';
import * as AuthService from '../../services/apifp';
import { useSelector } from 'react-redux';
import { ItemAdminShopData, fetchDropdownData, fetchEmployees } from '../../services/apifp';
import { logoutUser } from '@store/reducers/auth';
import { useDispatch } from 'react-redux';
// import TableAccounting from "./TableAccounting"; // ✅ Import ตารางบัญชี CD
const MyItemsAccountant = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [page2, setPage2] = useState(1);
  const [key, setKey] = useState('history');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [dropdowns, setDropdowns] = useState(null);
  const [filter, setFilter] = useState('');
  const [filter2, setFilter2] = useState('');
  const [employees, setEmployees] = useState([]); // ✅ เก็บข้อมูลพนักงาน
  const dispatch = useDispatch();
  const [loadingEmployees, setLoadingEmployees] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({
    status: '',
    searchs: '',
    // start: null,
    start: new Date(),
    end: new Date(),
    approvalReport: 'all',
    // end: moment()
  });

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const result = await AuthService.checkAdmin();
        console.log("🔍 ค่าที่ได้รับจาก API checkAdmin:", result.value);
        setIsAdmin(result.value);
        if (result.value === true) loadData('');
        else {
          setShowModal(false);
          setLoading(false);
        }
      } catch (error) {
        console.error("🚨 ตรวจสอบสิทธิ์แอดมินล้มเหลว:", error);

        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, []);

  // ✅ โหลดข้อมูลพนักงานเมื่อเปิดหน้า
  useEffect(() => {
    const loadEmployees = async () => {
      try {
        setLoadingEmployees(true);
        const data = await fetchEmployees();

        // console.log("📊 Employees Loaded:", data); // ✅ ตรวจสอบข้อมูลที่ได้
        if (!Array.isArray(data)) {
          throw new Error("🚨 fetchEmployees ไม่คืนค่าที่เป็น array");
        }

        setEmployees(data);
      } catch (error) {
        console.error("❌ โหลดพนักงานล้มเหลว:", error);
        toast.error("❌ ไม่สามารถโหลดข้อมูลพนักงาน");
        dispatch(logoutUser());
        window.location.href = "/login";
      } finally {
        setLoadingEmployees(false);
      }
    };

    loadEmployees();
  }, []);


  const loadData = async (useDateFilter = false) => {
    try {
      setLoading(true);
      let query = '';
      console.log(selectedStatus);
      if (selectedStatus.status === 'WA') {
        query = '%23approve';
      } else if (useDateFilter || selectedStatus.status === 'AP' || selectedStatus.status === 'RJ') {

        let _date_start = new Date(selectedStatus.start);
        let _date_end = new Date(selectedStatus.end);

        const offset = _date_start.getTimezoneOffset();
        _date_start = new Date(_date_start.getTime() - offset * 60 * 1000);
        _date_end = new Date(_date_end.getTime() - offset * 60 * 1000);

        // const params = await AuthService.downloadReportCourse({
        //   report_id: state.reportid.value,
        //   date_start: _date_start.toISOString().split('T')[0],
        //   date_end: _date_end.toISOString().split('T')[0]
        // });

        // const search = selectedStatus.searchs;
        // const type = selectedStatus.approvalReport || 'all';
        let type = selectedStatus.approvalReport === 'monthly2' ? 'monthly' : selectedStatus.approvalReport || 'all';

        //const startDate = selectedStatus.start.format('YYYY-MM-DD') || new Date().toISOString().split('T')[0];
        //const endDate = selectedStatus.end.format('YYYY-MM-DD') || new Date().toISOString().split('T')[0];
        //console.log(startDate);
        //console.log(endDate);
        query = `&start=${_date_start.toISOString().split('T')[0]}&end=${_date_end.toISOString().split('T')[0]}&type=${type}`;
      }

      console.log("🚀 Fetching Data from API with query:", query);
      const shopData = await ItemAdminShopData(query);
      console.log("✅ Data Received (Before Filter):", shopData);

      // ✅ เงื่อนไขกรองข้อมูลตาม status ที่เลือก
      let filteredData = shopData;
      if (selectedStatus.status === 'AP') {
        filteredData = shopData.filter((item) => item.STATUS === 'AP'); // เฉพาะ Approved
      } else if (selectedStatus.status === 'RJ') {
        filteredData = shopData.filter((item) => item.STATUS === 'RJ'); // เฉพาะ Rejected
      }
      console.log("✅ Data After Filter:", filteredData);

      setData(filteredData);
      setShowModal(false);
    } catch (error) {
      toast.error('ไม่สามารถโหลดข้อมูลได้');
      console.error('❌ Error fetching shop data:', error);
      dispatch(logoutUser());
      window.location.href = "/login";
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      const loadDropdowns = async () => {
        try {

          const dropdownData = await fetchDropdownData();
          setDropdowns(dropdownData);
        } catch (error) {
          console.error('Error fetching dropdown data:', error);
          toast.error('ไม่สามารถโหลดข้อมูล Dropdown ได้');
        }
      };

      loadDropdowns();
    }
  }, [showModal]);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleViewClick = (item) => {
    console.log("🔎 Item ที่ถูกคลิก:", item);
    setSelectedItem(item);
    setShowModal(true);
  };

  return (
    <div>
      <ContentHeader title="รายงานบัญชี" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                <Tab eventKey="history" title="ประวัติ">
                  {/* {loading ? (
                    <p>กำลังโหลดข้อมูล...</p>
                  ) : ( */}
                  <TableMyshopAccountant
                    setFilter={setFilter}
                    filter={filter}
                    loadData={loadData}
                    isAdmin={isAdmin}
                    selectedStatus={selectedStatus}
                    setSelectedStatus={setSelectedStatus}
                    items={data.map((e: any, i: any, arr: any) => ({
                      ...e,
                      _id: i + 1,
                      _idemp: user.ID_EMP,
                      _token: localStorage.getItem('gatekeeper_token'),
                      // _url: `https://api-zoom-v2.advanceagro.net/pdfapi/fastprint/${e.SHOP_ID}/${user.ID_EMP}?t=${localStorage.getItem('gatekeeper_token')}`
                    }))}
                    page={page}
                    onPageChange={(newPage) => setPage(newPage)}
                    onToggle={handleViewClick}
                    loading={loading}
                  />
                  {/* )} */}
                </Tab>
              </Tabs>

              <Modal show={showModal} className="modal-fullscreen" onHide={handleCloseModal} >
                <Modal.Header closeButton>
                  <Modal.Title>รายละเอียดร้านค้าของฉัน</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {selectedItem ? (
                    <ModalItemshopAccountant
                      shopId={selectedItem.SHOP_ID}
                      item={selectedItem}
                      // show={showModal}
                      dropdowns={dropdowns || {}}
                      loadData={loadData}
                    // onSave={(id, updatedItem) => {
                    //   setData((prevData: any) =>
                    //     prevData.map((shop: any) =>
                    //       shop.SHOP_ID === id ? { ...shop, ...updatedItem } : shop
                    //     )
                    //   );
                    // }}
                    // onHide={handleCloseModal}
                    />
                  ) : (
                    <p>กำลังโหลดข้อมูลร้านค้า...</p>
                  )}
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyItemsAccountant;
